import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PostComponent } from './components/posts/post/post.component';
import { PostsComponent } from './components/posts/posts.component';
import { ThemeSevenComponent } from './themes/theme-seven/theme-seven.component';

const routes: Routes = [
  {path: '', component: HomeComponent},
  {
    path: 'posts',
    component: PostsComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./components/posts/posts.module').then(m => m.PostsModule)
      },
    ]
  },
  {path: 'home', component: HomeComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
